export { default as Typography, Align, Color } from './Typography';
